export default __webpack_public_path__ + "static/media/013-croissant.df968431.svg";